<section class="spinner-background" [ngClass]="{ 'space-top': showNav }">
  <div>
    <img src="/assets/images/icons/grey-inyova.svg" />
    <h3 *ngIf="title?.length">{{ title | translate }}</h3>
    <div class="content">
      <ng-content></ng-content>
    </div>
  </div>
</section>
